import { render, staticRenderFns } from "./marketResource.vue?vue&type=template&id=11ff4c2e&scoped=true"
import script from "./marketResource.vue?vue&type=script&lang=js"
export * from "./marketResource.vue?vue&type=script&lang=js"
import style0 from "./marketResource.vue?vue&type=style&index=0&id=11ff4c2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff4c2e",
  null
  
)

export default component.exports